var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"comments",attrs:{"name":"fade","tag":"ul"}},_vm._l((_vm.sortedList),function(comment){return _c('CommentItem',{key:comment.id,attrs:{"comment":comment,"tag":"li"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }